import pageStyles from "../../../styles/page.module.css";
import Header from "../../header/Header";
import PageNavigation from "../../navigation/PageNavigation";
import ToastWrapper from "../../toaster/ToastWrapper";
import SkipLink from "../SkipLink";
import ImportValidationWarningDialog from "../../nexusLanding/ImportValidationWarningDialog";
import useImportValidationWarnings from "../../../hooks/useImportValidationWarnings";

export default function PageWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const importValidation = useImportValidationWarnings();

  return (
    <div className={pageStyles.pageWrapper}>
      <SkipLink />
      <Header />
      <main id="main-content" tabIndex={-1} className={pageStyles.pageBody}>
        <PageNavigation />
        {children}
      </main>
      <ToastWrapper></ToastWrapper>
      {importValidation.warnings && (
        <ImportValidationWarningDialog
          warnings={importValidation.warnings}
          onAcknowledge={importValidation.acknowledge}
        />
      )}
    </div>
  );
}
